export class AirportGroup {
  name: string;
  shortName: string;
}
